const isExternalURL = (url) => {
  if (!url) {
    return false;
  }
  if (url.startsWith("mailto:") || url.startsWith("tel:")) {
    return false;
  }
  try {
    const parsedURL = new URL(url, document.baseURI);
    const hostFromURL = parsedURL.hostname;
    const currentHost = window.location.hostname;
    return hostFromURL !== currentHost;
  } catch (error) {
    console.error("Invalid URL:", error);
    return false;
  }
};
export {
  isExternalURL
};
//# sourceMappingURL=url.mjs.map
